import { getUserInfo, login } from '@/api/user';
import { setToken } from '@/libs/util';
import loginState from '@/libs/loginState';
import { clearUserInfo } from '@/utils/localStorage';

export default {
    state: {
        userName: loginState.getLoginUserName(),
        userId: loginState.getLoginUserID(),
        avatorImgPath: loginState.getLoginAvator(),
        token: loginState.getLoginToken(),
        access: loginState.getLoginAccess(),
        personName: loginState.getPersonName(),
        personType: loginState.getPersonType(),
        personDept: loginState.getPersonDept(),
        userTypeInfo: loginState.getUserTypeInfo()
    },
    mutations: {
        setAvator(state, avatorPath) {
            state.avatorImgPath = avatorPath;
            loginState.setLoginAvator(avatorPath);
        },
        setUserId(state, id) {
            state.userId = id;
            loginState.setLoginUserID(id);
        },
        setUserName(state, name) {
            state.userName = name;
            loginState.setLoginUserName(name);
        },
        setAccess(state, access) {
            state.access = access;
            loginState.setLoginAccess(access);
        },
        setToken(state, token) {
            state.token = token;
            setToken(token);
            loginState.setLoginToken(token);
        },
        setPersonName(state, personName) {
            state.personName = personName;
            loginState.setPersonName(personName);
        },
        setPersonType(state, personType) {
            state.personType = personType;
            loginState.setPersonType(personType);
        },
        setPersonDept(state, personDept) {
            state.personDept = personDept;
            loginState.setPersonDept(personDept);
        },
        setUserTypeInfo(state, userTypeInfo) {
            state.userTypeInfo = userTypeInfo;
            loginState.setUserTypeInfo(userTypeInfo);
        }
    },
    actions: {
        // 登录
        handleLogin({ commit }, { userName, password }) {
            userName = userName.trim();
            return new Promise((resolve, reject) => {
                login({
                    userName,
                    password
                }).then(res => {
                    if (res.code === 0) {
                        const token = res.data.loginToken;
                        commit('setToken', token);
                    }
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            });
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            return new Promise((resolve, reject) => {
                commit('setToken', '');
                commit('setAccess', []);
                
                // 清除另一套存储系统的用户信息
                clearUserInfo();
                
                resolve();
            });
        },
        // 获取用户相关信息
        getUserInfo({ state, commit }) {
            return new Promise((resolve, reject) => {
                getUserInfo(state.token).then(res => {
                    if (res.code !== 0) {
                        return false;
                    }

                    // TODO 这里需要完善登录接口

                    const basicUserInfo = res.data.basicUserInfo;

                    commit('setAvator', '');
                    commit('setUserName', basicUserInfo.loginUserName);
                    commit('setPersonName', basicUserInfo.personName);
                    commit('setPersonType', basicUserInfo.userType);
                    commit('setPersonDept', basicUserInfo.userDept);
                    commit('setUserId', basicUserInfo.userUuid);
                    commit('setAccess', [basicUserInfo.userType]);
                    commit('setUserTypeInfo', '');

                    resolve(basicUserInfo);
                }).catch(err => {
                    reject(err);
                });
            });
        }
    }
};
